(() => {
  const toggle = document.querySelector('.yk-menu-toggle');
  const menu = document.getElementById('yk-mobile-menu');
  if (toggle && menu) {
    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
      toggle.textContent = open ? '×' : '☰';
      menu.hidden = !open;
    };
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
  }

  document.querySelectorAll('[data-yk-dialog]').forEach((button) => {
    button.addEventListener('click', () => {
      const dialog = document.getElementById(button.dataset.ykDialog);
      if (!dialog) return;
      const title = dialog.querySelector('[data-yk-dialog-title]');
      if (title && button.dataset.title) title.textContent = button.dataset.title;
      dialog.showModal();
    });
  });

  document.querySelectorAll('.yk-dialog').forEach((dialog) => {
    dialog.querySelector('.yk-dialog-close')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
    });
  });
})();
